exports.parse = require('./lib/parse');
exports.stringify = require('./lib/stringify');



/*****************
 ** WEBPACK FOOTER
 ** ./~/json-stable-stringify/~/jsonify/index.js
 ** module id = 216
 ** module chunks = 0
 **/